export const FirebaseConfig = {
  apiKey: "AIzaSyBUyxNpKTao0xdsUazDtNPNhBx8hCHubwM",
  authDomain: "new-tac.firebaseapp.com",
  databaseURL: "https://new-tac.firebaseio.com",
  projectId: "new-tac",
  storageBucket: "new-tac.appspot.com",
  messagingSenderId: "769105192191",
  appId: "1:769105192191:web:fc7b8c07f71e331230d8ca",
  measurementId: "G-KP587H4TVX"
};

export const google_map_key = 'AIzaSyBUyxNpKTao0xdsUazDtNPNhBx8hCHubwM';